module.exports = __webpack_public_path__ + "static/resume-cf1922d565f26a0b2682f60ab7ffdecb.pdf";